(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["3d-video-scrolling"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('unfold-scroll-video')) {
  customElements.define('unfold-scroll-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.journey = this.querySelector('.usv__journey');
      this.stage = this.querySelector('.usv__stage');
      this.error = this.querySelector('.usv__error');
      this.abort = new AbortController();
      this.mediaAbort = null;
      this.mobile = matchMedia('(max-width: 749px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.near = false;
      this.loaded = false;
      this.target = 0;
      this.viewport = innerHeight;
      this.viewportWidth = innerWidth;
      const options = { signal: this.abort.signal };
      this.queue = () => { if (!this.frame && this.isConnected) this.frame = requestAnimationFrame(() => this.update()); };
      this.onResize = () => {
        if (innerWidth === this.viewportWidth && (this.mobile.matches || innerHeight === this.viewport)) return;
        this.viewportWidth = innerWidth;
        this.viewport = innerHeight;
        this.configure();
      };
      window.addEventListener('scroll', this.queue, { ...options, passive: true });
      window.addEventListener('resize', this.onResize, options);
      window.addEventListener('orientationchange', () => {
        clearTimeout(this.orientationTimer);
        this.orientationTimer = setTimeout(() => { this.viewport = innerHeight; this.viewportWidth = innerWidth; this.configure(); }, 160);
      }, options);
      this.mobile.addEventListener('change', () => this.configure(), options);
      this.reduced.addEventListener('change', () => this.configure(), options);
      this.querySelector('.usv__retry')?.addEventListener('click', () => { this.loaded = false; this.configure(); this.loadSource(); }, options);
      this.observer = new IntersectionObserver(entries => {
        this.near = entries[0].isIntersecting;
        if (this.near) { this.loadSource(); this.queue(); }
      }, { rootMargin: '600px 0px' });
      this.observer.observe(this);
      this.configure();
    }
    configure() {
      this.video.pause();
      const mode = this.mobile.matches ? this.dataset.mobileMode : 'scroll';
      this.dataset.mode = mode === 'hide' ? 'hidden' : this.reduced.matches || this.dataset.editor === 'true' || mode === 'static' ? 'static' : 'scroll';
      const header = document.querySelector('.custom-header.is-sticky');
      const autoOffset = this.dataset.autoOffset === 'true' && header ? header.getBoundingClientRect().height : 0;
      const fullscreen = !this.mobile.matches && this.dataset.desktopFullscreen === 'true';
      this.offset = fullscreen ? 0 : Math.max(Number(this.dataset.offset) || 0, autoOffset);
      this.style.setProperty('--usv-viewport-width', document.documentElement.clientWidth + 'px');
      const styles = getComputedStyle(this);
      const heightPercent = parseFloat(styles.getPropertyValue(this.mobile.matches ? '--usv-mobile-height' : '--usv-height')) || 80;
      const height = fullscreen ? this.viewport : Math.max(200, Math.min(this.viewport * heightPercent / 100, this.viewport - this.offset - 16));
      this.travel = this.dataset.mode === 'scroll' ? this.viewport * (Number(this.mobile.matches ? this.dataset.mobileScreens : this.dataset.screens) || 2) : 0;
      this.style.setProperty('--usv-stage', height + 'px');
      this.style.setProperty('--usv-travel', this.travel + 'px');
      this.style.setProperty('--usv-offset', this.offset + 'px');
      this.video.controls = this.dataset.mode === 'static';
      this.video.muted = true;
      const source = this.mobile.matches ? this.dataset.mobileSrc || this.dataset.desktopSrc : this.dataset.desktopSrc || this.dataset.mobileSrc;
      if (source !== this.source) {
        this.source = source;
        this.loaded = false;
        this.duration = 0;
        this.mediaAbort?.abort();
        this.video.removeAttribute('src');
        this.video.querySelectorAll('source').forEach(node => node.remove());
        this.video.load();
      }
      if (this.dataset.mode === 'hidden') return;
      if (this.near || this.dataset.editor === 'true') this.loadSource();
      this.queue();
    }
    loadSource() {
      if (this.loaded || !this.source || this.dataset.mode === 'hidden') return;
      this.loaded = true;
      this.error.hidden = true;
      this.mediaAbort?.abort();
      this.mediaAbort = new AbortController();
      const options = { signal: this.mediaAbort.signal };
      const ready = () => {
        if (!Number.isFinite(this.video.duration) || this.video.duration <= 0) return;
        this.duration = this.video.duration;
        if (this.video.readyState >= 2) clearTimeout(this.loadTimer);
        this.queue();
      };
      this.video.addEventListener('loadedmetadata', ready, options);
      this.video.addEventListener('loadeddata', ready, options);
      this.video.addEventListener('seeked', this.queue, options);
      this.video.addEventListener('error', () => this.fail(), options);
      this.video.preload = this.dataset.mode === 'scroll' ? 'auto' : 'metadata';
      this.video.src = this.source;
      this.video.load();
      clearTimeout(this.loadTimer);
      this.loadTimer = setTimeout(() => { if (this.video.readyState < 2) this.fail(); }, 30000);
    }
    fail() {
      this.error.hidden = false;
      this.dataset.mode = 'static';
      this.travel = 0;
      this.style.setProperty('--usv-travel', '0px');
      clearTimeout(this.loadTimer);
    }
    update() {
      this.frame = null;
      if (!this.near || this.dataset.mode !== 'scroll' || !this.duration || !this.travel || !this.error.hidden) return;
      const progress = Math.min(1, Math.max(0, (this.offset - this.journey.getBoundingClientRect().top) / this.travel));
      this.target = Math.min(Math.max(0, this.duration - 0.04), progress * this.duration);
      if (this.video.seeking || this.video.readyState < 2 || Math.abs(this.video.currentTime - this.target) < 0.035) return;
      try { this.video.currentTime = this.target; } catch { }
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.mediaAbort?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      clearTimeout(this.loadTimer);
      clearTimeout(this.orientationTimer);
      this.video?.pause();
      this.video?.removeAttribute('src');
      this.video?.querySelectorAll('source').forEach(node => node.remove());
      this.video?.load();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    const scrollToProduct = () => {
      if (!window.location.hash) return;
      let id;
      try { id = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
      const card = document.getElementById(id);
      if (card && card.closest('results-list.unfold-collection')) card.scrollIntoView({ behavior: 'instant', block: 'start' });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scrollToProduct, { once: true });
    else scrollToProduct();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {
  const button = event.target.closest('.unfold-recommendations [data-ur-step]');
  if (!button) return;
  const list = button.closest('.unfold-recommendations').querySelector('[data-ur-list]');
  if (!list) return;
  const direction = getComputedStyle(list).direction === 'rtl' ? -1 : 1;
  list.scrollBy({left: Number(button.dataset.urStep) * direction * list.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unfold-announcement-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('unfold-announcement')) {
  customElements.define('unfold-announcement', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const button = this.querySelector('.ufa__pause');
      if (button) {
        button.hidden = false;
        button.addEventListener('click', () => {
          const paused = this.toggleAttribute('data-paused');
          button.setAttribute('aria-pressed', String(paused));
          button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        }, options);
      }
      this.sync = () => {
        this.frame = null;
        const header = document.querySelector('.custom-header.is-sticky');
        if (!header) return;
        if (this.header !== header) {
          this.restoreHeader();
          this.header = header;
          this.originalTop = header.style.top;
          this.originalOffset = header.style.getPropertyValue('--ufa-header-offset');
        }
        const offset = Math.max(0, this.getBoundingClientRect().bottom);
        header.style.top = offset + 'px';
        header.style.setProperty('--ufa-header-offset', offset + 'px');
        header.querySelectorAll('.custom-header__mega').forEach(menu => {
          if (!this.megaStyles.has(menu)) this.megaStyles.set(menu, menu.style.top);
          menu.style.top = 'calc(var(--header-height) + var(--ufa-header-offset, 0px))';
        });
      };
      this.megaStyles = new Map();
      this.queue = () => { if (!this.frame) this.frame = requestAnimationFrame(this.sync); };
      window.addEventListener('scroll', this.queue, { ...options, passive: true });
      window.addEventListener('resize', this.queue, options);
      document.addEventListener('DOMContentLoaded', this.queue, options);
      document.addEventListener('shopify:section:load', this.queue, options);
      this.observer = new ResizeObserver(this.queue);
      this.observer.observe(this);
      this.queue();
    }
    restoreHeader() {
      if (this.header) {
        this.header.style.top = this.originalTop;
        if (this.originalOffset) this.header.style.setProperty('--ufa-header-offset', this.originalOffset);
        else this.header.style.removeProperty('--ufa-header-offset');
      }
      this.megaStyles?.forEach((top, menu) => { menu.style.top = top; });
      this.megaStyles?.clear();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.restoreHeader();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unfold-floating-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('unfold-floating-hero')) {
  customElements.define('unfold-floating-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized || this.connectFrame) return;
      this.connectFrame = requestAnimationFrame(() => {
        this.connectFrame = null;
        if (this.isConnected) this.initialize();
      });
    }
    initialize() {
      if (this.initialized) return;
      if (!this.querySelector('[data-slide]')) {
        this.waitForSlides?.disconnect();
        this.waitForSlides = new MutationObserver(() => {
          if (!this.querySelector('[data-slide]')) return;
          this.waitForSlides.disconnect();
          this.initialize();
        });
        this.waitForSlides.observe(this, { childList:true, subtree:true });
        return;
      }
      this.initialized = true;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.objects = [...this.querySelectorAll('[data-object]')];
      this.index = -1;
      this.glowIndex = 0;
      this.userPaused = false;
      this.keyboardInteraction = false;
      this.visible = true;
      this.editing = false;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.dataset.preview = this.querySelector('.ufh__next-access')?.hidden ? 'false' : 'true';
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-next')) this.go(this.index + 1, true);
        if (button.hasAttribute('data-previous')) this.go(this.index - 1, true);
        if (button.hasAttribute('data-go')) this.go(Number(button.dataset.go), true);
        if (button.hasAttribute('data-pause')) {
          this.userPaused = !this.userPaused;
          button.setAttribute('aria-pressed', String(this.userPaused));
          button.setAttribute('aria-label', this.userPaused ? button.dataset.playLabel : button.dataset.pauseLabel);
          button.firstElementChild.textContent = this.userPaused ? '▶' : 'Ⅱ';
          this.schedule();
        }
      }, { signal });
      this.addEventListener('change', event => {
        if (!event.target.matches('input[type="radio"][name="id"]')) return;
        const input = event.target;
        const purchase = input.closest('[data-purchase]');
        const price = purchase.querySelector('span[data-price]');
        const compare = purchase.querySelector('s[data-compare]');
        if (price) price.textContent = input.dataset.price;
        if (compare) { compare.textContent = input.dataset.compare; compare.hidden = !input.dataset.compare; }
        purchase.querySelector('input[name="quantity"]').value = input.dataset.quantity;
      }, { signal });
      document.addEventListener('pointerdown', () => {
        this.keyboardInteraction = false;
        this.schedule();
      }, { signal, capture:true });
      document.addEventListener('keydown', () => {
        this.keyboardInteraction = true;
        this.schedule();
      }, { signal, capture:true });
      this.addEventListener('focusin', () => this.schedule(), { signal });
      this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), { signal });
      this.addEventListener('keydown', event => {
        if (event.target.matches('input,select,textarea') || this.slides.length < 2) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
        }
      }, { signal });
      let touch;
      const stage = this.querySelector('.ufh__stage');
      stage?.addEventListener('click', event => {
        if (event.target.closest('.ufh__image-link') && (this.busy || performance.now() < (this.suppressImageClickUntil || 0))) event.preventDefault();
      }, { capture:true,signal });
      stage?.addEventListener('touchstart', event => { touch = event.touches.length === 1 ? { x:event.touches[0].clientX,y:event.touches[0].clientY } : null; }, { passive:true,signal });
      stage?.addEventListener('touchend', event => {
        if (!touch || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - touch.x;
        const dy = event.changedTouches[0].clientY - touch.y;
        if (Math.abs(dx) > 10 || Math.abs(dy) > 10) this.suppressImageClickUntil = performance.now() + 500;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.go(this.index + (dx < 0 ? 1 : -1), true);
        touch = null;
      }, { passive:true,signal });
      document.addEventListener('visibilitychange', () => this.schedule(), { signal });
      this.reduced.addEventListener('change', () => this.schedule(), { signal });
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index < 0) return;
        this.editing = true;
        this.go(index, false, true);
        this.schedule();
      }, { signal });
      document.addEventListener('shopify:block:deselect', event => {
        if (!this.slides.some(slide => slide.dataset.blockId === event.detail.blockId)) return;
        this.editing = false;
        this.schedule();
      }, { signal });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          const visible = entries[0].isIntersecting;
          if (visible === this.visible) return;
          this.visible = visible;
          this.schedule();
        }, { threshold:0 });
        this.observer.observe(this);
      }
      this.mobileFitWidth = null;
      this.mobileFitOrientation = null;
      this.fitMobile = (force = false) => {
        const width = document.documentElement.clientWidth;
        const orientation = window.screen.orientation?.type || (typeof window.orientation === 'number' ? String(window.orientation) : (window.screen.width > window.screen.height ? 'landscape' : 'portrait'));
        if (!window.matchMedia('(max-width: 599px)').matches) {
          this.style.removeProperty('--ufh-mobile-fit');
          this.style.removeProperty('--ufh-mobile-viewport');
          this.removeAttribute('data-mobile-compact');
          this.mobileFitWidth = null;
          this.mobileFitOrientation = null;
          return;
        }
        if (force !== true && width === this.mobileFitWidth && orientation === this.mobileFitOrientation) return;
        const probe = document.createElement('div');
        probe.style.cssText = 'position:fixed;inset:0 auto auto 0;width:0;height:100svh;visibility:hidden;pointer-events:none;';
        document.body.append(probe);
        const smallViewport = probe.getBoundingClientRect().height;
        probe.remove();
        const viewport = smallViewport || window.innerHeight;
        const pageTop = this.getBoundingClientRect().top + window.scrollY;
        const topSpace = pageTop >= 0 && pageTop <= 240 ? pageTop : 80;
        const height = Math.max(240, Math.floor(viewport - topSpace - 16));
        this.style.setProperty('--ufh-mobile-viewport', viewport + 'px');
        this.style.setProperty('--ufh-mobile-fit', height + 'px');
        this.toggleAttribute('data-mobile-compact', viewport <= 600);
        this.mobileFitWidth = width;
        this.mobileFitOrientation = orientation;
      };
      window.addEventListener('resize', this.fitMobile, { signal });
      window.screen.orientation?.addEventListener('change', () => requestAnimationFrame(() => {
        if (this.isConnected) this.fitMobile(true);
      }), { signal });
      this.fitMobile(true);
      document.fonts?.ready.then(() => {
        if (this.isConnected && window.scrollY < 2) this.fitMobile(true);
      });
      this.go(0, false, true);
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.userPaused || this.busy || this.editing || this.reduced.matches || !this.visible || document.hidden || (this.keyboardInteraction && this.contains(document.activeElement))) return;
      const interval = Math.max(1000, Number(this.dataset.interval) || 5000);
      this.timer = setTimeout(() => this.go(this.index + 1), interval);
    }
    go(next, manual = false, immediate = false) {
      if (!this.slides.length || (this.busy && !immediate)) return;
      next = Number(next);
      if (!Number.isFinite(next)) return;
      next = ((Math.trunc(next) % this.slides.length) + this.slides.length) % this.slides.length;
      if (next === this.index) { this.schedule(); return; }
      clearTimeout(this.timer);
      clearTimeout(this.release);
      this.busy = true;
      const old = this.index;
      this.index = next;
      const slide = this.slides[next];
      const glowLayers = this.querySelectorAll('[data-glow-layer]');
      this.glowIndex = 1 - this.glowIndex;
      if (glowLayers[this.glowIndex]) glowLayers[this.glowIndex].style.background = `radial-gradient(ellipse at 50% 42%, ${slide.dataset.glow}, transparent 70%)`;
      glowLayers.forEach((layer,index) => layer.style.opacity = index === this.glowIndex ? '1' : '0');
      const variables = { bg:'bg',glow:'glow',text:'text',button:'button','button-text':'buttonText',scale:'scale','scale-mobile':'mobileScale' };
      Object.entries(variables).forEach(([property,key]) => this.style.setProperty('--ufh-' + property, slide.dataset[key]));
      this.querySelectorAll('[data-content],[data-purchase],[data-tagline]').forEach(panel => {
        const position = Number(panel.dataset.content ?? panel.dataset.purchase ?? panel.dataset.tagline);
        if (position !== next && panel.contains(document.activeElement)) {
          this.querySelector('[data-go="' + next + '"]')?.focus({ preventScroll:true });
        }
        panel.hidden = position !== next;
      });
      this.objects.forEach((object,index) => {
        const link = object.querySelector('.ufh__image-link');
        if (link) {
          link.tabIndex = index === next ? 0 : -1;
          link.setAttribute('aria-hidden', String(index !== next));
        }
        object.dataset.pose = index === next ? 'active'  : index === old ? 'exit' : index === (next + 1) % this.slides.length ? 'preview' : 'hidden';
      });
      this.querySelectorAll('[data-go]').forEach(button => button.setAttribute('aria-current', String(Number(button.dataset.go) === next)));
      if (manual && this.querySelector('[data-status]')) this.querySelector('[data-status]').textContent = slide.dataset.heading;
      this.release = setTimeout(() => {
        this.objects.forEach((object,index) => { object.dataset.pose = index === next ? 'active' : index === (next + 1) % this.slides.length ? 'preview' : 'hidden'; });
        this.busy = false;
        this.schedule();
      }, immediate || this.reduced.matches ? 0 : Math.min(3000, Math.max(0, Number(this.dataset.duration) || 850)));
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.connectFrame);
      this.connectFrame = null;
      this.waitForSlides?.disconnect();
      this.busy = false;
      clearTimeout(this.timer);
      clearTimeout(this.release);
      this.abort?.abort();
      this.observer?.disconnect();
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
